// Capture les params UTM (utm_source, utm_medium, utm_campaign, etc.)
// au chargement du site, persiste en sessionStorage, et expose pour
// enrichir tous les events tracking.
//
// Pattern standard reconnu par Meta Ads, Google Ads, GA4. Permet
// d'attribuer chaque conversion (réservation, candidature) à la
// campagne d'origine.
//
// sessionStorage = expire à la fermeture du browser (cohérent : on
// veut attribuer la visite, pas re-attribuer une visite ultérieure).

const STORAGE_KEY = 'baralambic-utm';

export interface UtmParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}

function parseFromUrl(): UtmParams {
  const params = new URLSearchParams(window.location.search);
  const out: UtmParams = {};
  for (const key of [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ] as const) {
    const value = params.get(key);
    if (value) out[key] = value;
  }
  return out;
}

export function initUtm(): void {
  const fromUrl = parseFromUrl();
  // On garde la 1re campagne vue cette session : si l'utilisateur
  // navigue ensuite vers une URL sans utm, on ne perd pas l'attribution.
  if (Object.keys(fromUrl).length > 0) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(fromUrl));
    } catch {
      // sessionStorage indispo (mode privé strict) — on ignore.
    }
  }
}

export function getUtm(): UtmParams {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return typeof parsed === 'object' && parsed !== null ? parsed : {};
  } catch {
    return {};
  }
}
